export function convertPercentToAmount(rate,percentage){
    const amount = (percentage/100)*rate
    return Number(amount.toFixed(2))
}

export function getPaymentGatewayId(name) {
    switch(name){
        case "Paytm":return 1;
        case "ICICI":return 2;
        case "HDFC":return 3;
        case "HDFC Razorpay":return 4;
        case "Razorpay":return 5;
        default : return 5;
    }
}
